import Vue from 'vue'
import './shop'
import './users'

import Winding from './Winding';
import FindTransformers from './find/FindTransformers';
import ShopFeedback from './ShopFeedback';
import GroupView from './GroupView';

Vue.component('winding', Winding);
Vue.component('find-transformers', FindTransformers);
Vue.component('shop-feedback', ShopFeedback);
Vue.component('group-view', GroupView);



// WEBPACK FOOTER //
// ./components/components.js